import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface TicketPropertyPillProps {
  icon: ReactNode;
  label: string;
  className?: string;
}

export const TicketPropertyPill: FC<TicketPropertyPillProps> = ({
  icon,
  label,
  className,
}) => (
  <div
    className={cx(
      "flex w-fit max-w-full min-w-0 items-center rounded-lg border border-solid border-grey-300 bg-white px-2.5 py-1.5 select-none",
      className
    )}
  >
    <div className="flex min-w-0 items-center gap-2 overflow-hidden">
      <span className="flex shrink-0 items-center justify-center">{icon}</span>
      <span
        className="min-w-0 truncate font-primary text-xs leading-[1.4] font-medium text-dark capitalize"
        title={label}
      >
        {label}
      </span>
    </div>
  </div>
);
